// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-js .vjs-big-play-button{left:50%;top:50%;transform:translateX(-50%) translateY(-50%)}", ""]);
// Exports
module.exports = exports;
